module.exports = __webpack_public_path__ + "static/logo-ded4ee220627d8d02dde435f7cece766.png";